import React, { type JSX } from 'react';

import clsx from 'clsx';
import moment from 'moment-timezone';
import { useTransformData } from 'hooks/useTransformData';
import { triggerExternalClick } from '@fiji/common/src/features/component/schedule/scheduleSlice';
import { Box, Grid, Stack, Typography } from '@mui/material';
import { useAppDispatch, useTypedSelector } from '@fiji/common';

export const EventGrid = ({ event, hideName }: { event: any; hideName?: boolean; eventsArr?: any }): JSX.Element => {
    const currentTime = useTypedSelector((state) => state.schedule.currentTime);
    const { timezone: selectedTimezone } = useTransformData();
    const dispatch = useAppDispatch();

    const start = moment.tz(event?.schedules?.[0], selectedTimezone);
    const end = event?.actionEndTime ? moment.tz(event?.actionEndTime, selectedTimezone) : null;
    const now = moment.tz(currentTime, selectedTimezone);

    const startHour = start.hour();
    const startMinutes = start.minute();

    return end ? (
        <Grid
            key={event?.id}
            style={{
                position: 'absolute',
                height: '50%',
                ...(event?.top && { top: event?.top }),
                minWidth: `${(end.diff(start, 'minutes') / 1440) * 100}%`,
                left: `${((startHour * 60 + startMinutes) / 1440) * 100}%`,
                zIndex: 1,
            }}
            className={clsx({
                'ongoing-event': now.isBetween(start, end, undefined, '[]'),
                'margin-y-8': true,
                'future-event': now.isBefore(start),
                'past-event': now.isAfter(end),
            })}
            size={0.5}
        >
            <Typography variant="body2" className="text-truncate">
                {!hideName && event?.name}
            </Typography>
        </Grid>
    ) : (
        <Stack
            sx={{
                position: 'absolute',
                height: '50%',
                left: `${((startHour * 60 + startMinutes) / 1440) * 100}%`,
                zIndex: 1,
                ...(event?.top && { top: event?.top }),
            }}
            key={event?.id}
            direction={'row'}
            spacing={1}
            alignItems={'center'}
            className={clsx({
                'margin-y-8': true,
                //'min-width=150 ': true,
                'past-text-event': now.isAfter(start),
                'future-text-event': now.isBefore(start),
                'ongoing-text-event': now.isSame(start),
            })}
        >
            <Box
                className="dot"
                onClick={() => {
                    dispatch(triggerExternalClick(event));
                }}
            />
            <Typography variant="body2" className="text-truncate">
                {event?.name}
            </Typography>
        </Stack>
    );
};
